import ReducersTooling from '../../../tooling/reducersTooling';

const initialState = {
  periodsList: ReducersTooling.initialStates.getFetchTypeInitialStateList(),
  save: ReducersTooling.initialStates.getFetchTypeInitialState(),
  findActive: ReducersTooling.initialStates.getFetchTypeInitialState(),
  changePeriodState: ReducersTooling.initialStates.getFetchTypeInitialState(),
  closePeriod: ReducersTooling.initialStates.getFetchTypeInitialState(),
  groupsFilter: ReducersTooling.initialStates.getFetchTypeInitialStateList(),
  calculationUnitsFilter: ReducersTooling.initialStates.getFetchTypeInitialStateList(),
  metricsGroupsWithDefaults: ReducersTooling.initialStates.getFetchTypeInitialState(),
  import: ReducersTooling.initialStates.getFetchTypeInitialState(),
  downloadImport: ReducersTooling.initialStates.getFetchTypeInitialState(),
  importFilesList: ReducersTooling.initialStates.getFetchTypeInitialState(),
  calculate: ReducersTooling.initialStates.getFetchTypeInitialState(),
  calculationsHistory: ReducersTooling.initialStates.getFetchTypeInitialStateList(),
  deleteCalculation: ReducersTooling.initialStates.getFetchTypeInitialStateDelete(),
  downloadCalculationReport: ReducersTooling.initialStates.getFetchTypeInitialState(),
  downloadCalculationUnifiedReport: ReducersTooling.initialStates.getFetchTypeInitialState(),
  polynomialsList: ReducersTooling.initialStates.getFetchTypeInitialStateList(),
  polynomialsSubModelList: ReducersTooling.initialStates.getFetchTypeInitialStateList(),
  metricsDataUploadInfo: [],
  processingMetricsImportsNotifications: ReducersTooling.initialStates.getFetchTypeInitialStateList(),
  biTemplatesList: ReducersTooling.initialStates.getFetchTypeInitialStateList(),
  exportBiReports: ReducersTooling.initialStates.getFetchTypeInitialState(),
  polynomialFilterTreeInfo: ReducersTooling.initialStates.getFetchTypeInitialState(),
  getCustomer: ReducersTooling.initialStates.getFetchTypeInitialState(),
  rollBackPeriod: ReducersTooling.initialStates.getFetchTypeInitialState(),
  refreshVirtualMetricData: ReducersTooling.initialStates.getFetchTypeInitialState(),
};

export default initialState;



// WEBPACK FOOTER //
// ./source/client/reducers/periodAdmin/initialState.js